import {
  mapTeamType,
  mapUserType,
  TeamType,
  UserType,
  useFindTaskAssignableTeamsSuspense,
  useFindTaskAssignableUsersSuspense,
} from '@api';

type UseTaskAssignablesSuspenseReturnType = {
  assignableUsers: UserType[];
  assignableTeams: TeamType[];
};

export const useTaskAssignablesSuspense =
  (): UseTaskAssignablesSuspenseReturnType => {
    const { data: assignableUsers } = useFindTaskAssignableUsersSuspense({
      query: {
        select: (response) => response.data.map(mapUserType),
      },
    });
    const { data: assignableTeams } = useFindTaskAssignableTeamsSuspense({
      query: {
        select: (response) => response.data.map(mapTeamType),
      },
    });

    return {
      assignableUsers,
      assignableTeams,
    };
  };
